module.exports = __webpack_public_path__ + "media/shared/components/Payment/pic_secure-c956b13ad3bac484c65d28dc93061255.png";